import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, Divider, Typography } from '@mui/material';
import React from 'react';
import { useDeliveryStore } from '../../store/deliveryStore';

interface Props {
  onNovoPedido: () => void;
}

export default function StepConfirmacao({ onNovoPedido }: Props) {
  const { codigoSolicitacao, nomeContato, unidade } = useDeliveryStore();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      py={6}
      gap={2}
    >
      <CheckCircleIcon sx={{ fontSize: 88, color: 'success.main' }} />

      <Typography variant="h5" fontWeight={800}>
        Pedido enviado!
      </Typography>

      <Typography color="text.secondary" maxWidth={320}>
        Obrigado, <strong>{nomeContato}</strong>! Recebemos seu pedido e em breve o estabelecimento entrará em contato.
      </Typography>

      {codigoSolicitacao && (
        <Box
          sx={{
            bgcolor: 'action.hover', borderRadius: 2,
            px: 3, py: 1.5, mt: 1,
          }}
        >
          <Typography variant="caption" color="text.secondary">
            Número do pedido
          </Typography>
          <Typography variant="h6" fontWeight={700}>
            #{codigoSolicitacao}
          </Typography>
        </Box>
      )}

      {unidade?.empresaTelefone && (
        <>
          <Divider sx={{ width: '100%', my: 1 }} />
          <Typography variant="body2" color="text.secondary">
            Dúvidas? Fale com o estabelecimento:
          </Typography>
          <Typography variant="body1" fontWeight={600}>
            {unidade.empresaTelefone}
          </Typography>
        </>
      )}

      <Button
        variant="contained"
        size="large"
        onClick={onNovoPedido}
        sx={{ mt: 3, borderRadius: 3, px: 4 }}
      >
        Fazer novo pedido
      </Button>
    </Box>
  );
}
